'use client'

import { LanguageISO6391 } from 'ai-constants'
import { createInstance } from 'i18next'
import { initReactI18next } from 'react-i18next'
import { getI11nOptions } from './resources'

let initialized = false
const i18next = createInstance()

export const initializeI11n = () => {
  if (initialized) return i18next

  void i18next.use(initReactI18next).init(getI11nOptions())

  initialized = true

  return i18next
}

initializeI11n()

export const getI11nInstance = () => initializeI11n()

export const changeI11nLanguage = (lang: LanguageISO6391) => {
  const instance = initializeI11n()

  if (instance.resolvedLanguage === lang) return Promise.resolve(instance)

  return instance.changeLanguage(lang)
}
